import { appConstants } from "JS/Helpers/Constants";
import { BaseService } from "../BaseService";

class VersionService extends BaseService {
    getVersion = (version: string, isBeta: boolean) =>
        this.ngCall<boolean>("get", appConstants.ngEndpoints.version, {
            params: {
                version,
                isBeta,
            },
        });
}

export default VersionService;
